import SupportCard from "src/components/SupportCard";
import { Grid, Box } from "@mui/material";
import { GridContainerStyled } from "./styled";
import LinkText from "../LinkText";
import { PhoneStreamlineIcon } from "../icons";
import LinksSection from "../SupportCard/linksSection";
import { IconWithBackgroundColor } from "../IconWithBackgroundColor";
import { useThemeColor } from "src/hooks/useThemeColor";
import { BenefitInfo } from 'src/types';
import GroupBySubject from "./utils/groupSubjectLogic";

export default function SupportComponent({ data }: { data: BenefitInfo[] }) {
  return (
    <>
      <GridContainerStyled container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <SupportCard
            color="bhYellow0"
            icon={<IconWithBackgroundColor icon='AmbulanceCallStreamlineIcon' color='bhYellow0' />}
            title="Emergency Care"
            description="If you are currently experiencing a mental health emergency or having thoughts of self harm and suicide, please call 911 or go to the nearest emergency room"
            actionComponent={
              <LinkText url="tel:911" text="Call 911 - Emergency Support" icon={<PhoneStreamlineIcon style={{ marginRight: 8, color: useThemeColor('neutral60') }} />} />
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SupportCard
            color="bhYellow0"
            icon={<IconWithBackgroundColor icon='CallCenter24StreamlineIcon' color='bhYellow0' />}
            title="Need help?"
            description="If you are not in immediate danger but would like help, you can call or text a trained crisis worker who can give you immediate support. These services are all free, confidential, and available 24/7."
            actionComponent={
              <Box>
                {Object.entries(GroupBySubject(data)).map(([subject, actions]) => (
                  <LinksSection key={subject} subject={subject} actions={actions} />
                ))}
              </Box>
            }
          />
        </Grid>
      </GridContainerStyled>
    </>
  );
}


